import {MethodType, ParamsFetchType, GenerateUrlApiType, ResponseType} from 'src_common/browser/apiUtils';
import { GenerateUrlApiParamsType } from 'src_common/server/webDriver/sdkApiWebUtils';
import { openapi_website_cms_createPage, decodeResponse200, Response200Type } from 'src/api_openapi/generated/openapi_website_cms_createPage';


export type TransactionItemType = Response200Type extends Array<infer Model> ? Model : never;

const decode = (status: number, data: ResponseType): Response200Type  => {
    if (status === 200 && data.type === 'json') {
        return decodeResponse200(data.json);
    }

    throw new Error(`unhandled response ${status} - ${data.type}`);
};

export interface PageType {
    slug: string,
    title: string,
    content: string,
    page_description: string,
    keywords: string,
    seo_title: string,
    universe: string,
    page_language: string,
}




export interface PostPageType {
    page: PageType
}

export const postPage = {
    browser: {
        params: (params: PostPageType): ParamsFetchType<PostPageType> => {
            return {
                type: MethodType.POST,
                url: '/api-web/post-page',
                body: params
            };
        },
        decode: decode
    },
    express: {
        method: MethodType.POST,
        urlBrowser: '/api-web/post-page',
    },
    generateUrlApi: async (params: GenerateUrlApiParamsType<PostPageType>): Promise<GenerateUrlApiType> => {
        const resp = await openapi_website_cms_createPage(params.API_URL, params.API_TIMEOUT, params.jwtToken, {
            universe: params.API_UNIVERSE,
            body: params.req.body.page
        });

        return {
            passToBackend: false,
            status: resp.status,
            responseBody: resp.body,
        };
    }
};
